export const USER_CREDIT_REGULAR_POLLING_INTERVAL_IN_MS = 30 * 1000;
export const USER_CREDIT_MANUAL_POLLING_INTERVAL_IN_MS = 3.5 * 1000;
export const USER_CREDIT_MANUAL_POLLING_AMOUNT = 3;
